export enum AibTransactionStateEnum {
  CAPTURED = 'CAPTURED',
  AUTHORIZED = 'AUTHORIZED',
  DECLINED = 'DECLINED',
  VOIDED = 'VOIDED',
  SETTLED = 'SETTLED'
}

export enum AibTransactionTypeEnum {
  SALE = 'SALE',
  PREAUTH = 'PREAUTH',
  POSTAUTH = 'POSTAUTH',
  VOID = 'VOID',
  RETURN = 'RETURN',
}
